import {IOfferDetail} from "../../../offer/types/IOfferDetail";
import {OfferType} from "../../../offer/types/OfferType";
import {getQuarterTypeName, getQuarterTypeNamePL, QuarterType} from "../../../property/components/PropertyDetailGeneratedDescriptionFlat";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {FloorChoice} from "../../../real_estate/types/FloorChoice";
import {IUserPreferences} from "../../../user/interfaces/IUserPreferences";
import {IPropertyDetailBoosterStats} from "../BoosterDetail.test";

export enum RoomChoice {
    ONE_ROOM = 1,
    TWO_ROOMS,
    THREE_ROOMS,
    FOUR_ROOMS,
    FIVE_OR_MORE_ROOMS
}

export const getBoosterAreaStats = (offer: IOfferDetail | IPropertyDetailOffer, userPref: IUserPreferences) => {
    const userMaxArea = Number(userPref.filters?.area_1);
    const buildingParams = offer?.stats?.building_parameters_stats;
    if (userMaxArea < 45 && buildingParams) {
        return {left: buildingParams.properties_to_45m.left, total: buildingParams.properties_to_45m.total, type: "do 45m2"};
    } else if (userMaxArea < 60 && buildingParams) {
        return {left: buildingParams.properties_45m_to_60m.left, total: buildingParams.properties_45m_to_60m.total, type: "do 60m2"};
    } else if (userMaxArea > 60 && buildingParams) {
        return {left: buildingParams.properties_over_60m.left, total: buildingParams.properties_over_60m.total, type: "powyżej 60m2"};
    }
};

export const getBoosterRoomStats = (offer: IOfferDetail | IPropertyDetailOffer, userPref: IUserPreferences) => {
    const userRooms = Number(userPref.filters?.rooms_0);
    const buildingParams = offer.stats?.building_parameters_stats;
    switch (userRooms) {
        case RoomChoice.ONE_ROOM:
            return buildingParams && {left: buildingParams.properties_1room.left, total: buildingParams?.properties_1room.total, type: "z 1 pokojem"};
        case RoomChoice.TWO_ROOMS:
            return buildingParams && {left: buildingParams.properties_2rooms.left, total: buildingParams?.properties_2rooms.total, type: "z 2 pokojami"};

        case RoomChoice.THREE_ROOMS:
            return buildingParams && {left: buildingParams.properties_3rooms.left, total: buildingParams?.properties_3rooms.total, type: "z 3 pokojami"};

        case RoomChoice.FOUR_ROOMS:
            return buildingParams && {left: buildingParams.properties_4rooms.left, total: buildingParams?.properties_4rooms.total, type: "z 4 pokojami"};
        case RoomChoice.FIVE_OR_MORE_ROOMS:
            return (
                buildingParams && {
                    left: buildingParams.properties_5rooms_or_more.left,
                    total: buildingParams.properties_5rooms_or_more.total,
                    type: "z 5 pokojami lub więcej"
                }
            );
    }
};

export const getBoosterFloorStats = (offer: IOfferDetail | IPropertyDetailOffer, userPref: IUserPreferences) => {
    const userFloor = userPref?.filters?.floor_choices;
    const buildingParams = offer.stats?.building_parameters_stats;
    switch (true) {
        case userFloor?.includes(FloorChoice.LOW_LEVELS.toString()):
            return (
                buildingParams && {
                    left: buildingParams.properties_on_low_floor.left,
                    total: buildingParams.properties_on_low_floor.total,
                    type: "na niskim piętrze"
                }
            );
        case userFloor?.includes(FloorChoice.HIGH_LEVELS.toString()):
            return (
                buildingParams && {
                    left: buildingParams.properties_on_middle_floors.left,
                    total: buildingParams.properties_on_middle_floors.total,
                    type: "na średnim piętrze"
                }
            );
        case userFloor?.includes(FloorChoice.LAST_LEVEL_WITH_TERRACE.toString()):
        case userFloor?.includes(FloorChoice.LAST_LEVEL.toString()):
            return (
                buildingParams && {
                    left: buildingParams.properties_on_high_floors.left,
                    total: buildingParams.properties_on_high_floors.total,
                    type: "na wysokim piętrze"
                }
            );
    }
};

export const getUserFilterChoice = (userPref: IUserPreferences, offer: IOfferDetail | IPropertyDetailOffer) => {
    const areaStats = getBoosterAreaStats(offer, userPref);
    const roomStats = getBoosterRoomStats(offer, userPref);
    const floorStats = getBoosterFloorStats(offer, userPref);

    if (userPref.filters?.area_1 && (areaStats?.left === 1 || areaStats?.left === 2) && areaStats.total && areaStats.total > 2) {
        return "area";
    } else if (userPref.filters?.rooms_0 && (roomStats?.left === 1 || roomStats?.left === 2) && roomStats.total && roomStats.total > 2) {
        return "rooms";
    } else if (
        userPref.filters?.floor_choices &&
        (floorStats?.left === 1 || floorStats?.left === 2) &&
        floorStats.total &&
        floorStats.total > 2 &&
        offer.type === OfferType.FLAT
    ) {
        return "floor";
    }
};

export const getQuarterStats = (quarter: QuarterType, offer: IOfferDetail | IPropertyDetailOffer, property?: IPropertyDetailBoosterStats) => {
    const buildingParam = !property ? offer?.stats?.building_parameters_stats : property.offer.stats?.building_parameters_stats;
    const quarterName = getQuarterTypeName(quarter);
    const quarterNamePL = getQuarterTypeNamePL(quarter);
    return property?.quarters?.includes(quarter) && buildingParam && quarterName
        ? {
              left: buildingParam[`properties_${quarterName}_quarter`]?.left,
              total: buildingParam[`properties_${quarterName}_quarter`]?.total,
              type: quarterNamePL
          }
        : !property && buildingParam && quarterName
          ? {
                left: buildingParam[`properties_${quarterName}_quarter`]?.left,
                total: buildingParam[`properties_${quarterName}_quarter`]?.total,
                type: quarterNamePL
            }
          : undefined;
};
import {IOfferDetail} from "../../../offer/types/IOfferDetail";
import {OfferType} from "../../../offer/types/OfferType";
import {getQuarterTypeName, getQuarterTypeNamePL, QuarterType} from "../../../property/components/PropertyDetailGeneratedDescriptionFlat";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {FloorChoice} from "../../../real_estate/types/FloorChoice";
import {IUserPreferences} from "../../../user/interfaces/IUserPreferences";
import {IPropertyDetailBoosterStats} from "../BoosterDetail.test";

export enum RoomChoice {
    ONE_ROOM = 1,
    TWO_ROOMS,
    THREE_ROOMS,
    FOUR_ROOMS,
    FIVE_OR_MORE_ROOMS
}

export const getBoosterAreaStats = (offer: IOfferDetail | IPropertyDetailOffer, userPref: IUserPreferences) => {
    const userMaxArea = Number(userPref.filters?.area_1);
    const buildingParams = offer?.stats?.building_parameters_stats;
    if (userMaxArea < 45 && buildingParams) {
        return {left: buildingParams.properties_to_45m.left, total: buildingParams.properties_to_45m.total, type: "do 45m2"};
    } else if (userMaxArea < 60 && buildingParams) {
        return {left: buildingParams.properties_45m_to_60m.left, total: buildingParams.properties_45m_to_60m.total, type: "do 60m2"};
    } else if (userMaxArea > 60 && buildingParams) {
        return {left: buildingParams.properties_over_60m.left, total: buildingParams.properties_over_60m.total, type: "powyżej 60m2"};
    }
};

export const getBoosterRoomStats = (offer: IOfferDetail | IPropertyDetailOffer, userPref: IUserPreferences) => {
    const userRooms = Number(userPref.filters?.rooms_0);
    const buildingParams = offer.stats?.building_parameters_stats;
    switch (userRooms) {
        case RoomChoice.ONE_ROOM:
            return buildingParams && {left: buildingParams.properties_1room.left, total: buildingParams?.properties_1room.total, type: "z 1 pokojem"};
        case RoomChoice.TWO_ROOMS:
            return buildingParams && {left: buildingParams.properties_2rooms.left, total: buildingParams?.properties_2rooms.total, type: "z 2 pokojami"};

        case RoomChoice.THREE_ROOMS:
            return buildingParams && {left: buildingParams.properties_3rooms.left, total: buildingParams?.properties_3rooms.total, type: "z 3 pokojami"};

        case RoomChoice.FOUR_ROOMS:
            return buildingParams && {left: buildingParams.properties_4rooms.left, total: buildingParams?.properties_4rooms.total, type: "z 4 pokojami"};
        case RoomChoice.FIVE_OR_MORE_ROOMS:
            return (
                buildingParams && {
                    left: buildingParams.properties_5rooms_or_more.left,
                    total: buildingParams.properties_5rooms_or_more.total,
                    type: "z 5 pokojami lub więcej"
                }
            );
    }
};

export const getBoosterFloorStats = (offer: IOfferDetail | IPropertyDetailOffer, userPref: IUserPreferences) => {
    const userFloor = userPref?.filters?.floor_choices;
    const buildingParams = offer.stats?.building_parameters_stats;
    switch (true) {
        case userFloor?.includes(FloorChoice.LOW_LEVELS.toString()):
            return (
                buildingParams && {
                    left: buildingParams.properties_on_low_floor.left,
                    total: buildingParams.properties_on_low_floor.total,
                    type: "na niskim piętrze"
                }
            );
        case userFloor?.includes(FloorChoice.HIGH_LEVELS.toString()):
            return (
                buildingParams && {
                    left: buildingParams.properties_on_middle_floors.left,
                    total: buildingParams.properties_on_middle_floors.total,
                    type: "na średnim piętrze"
                }
            );
        case userFloor?.includes(FloorChoice.LAST_LEVEL_WITH_TERRACE.toString()):
        case userFloor?.includes(FloorChoice.LAST_LEVEL.toString()):
            return (
                buildingParams && {
                    left: buildingParams.properties_on_high_floors.left,
                    total: buildingParams.properties_on_high_floors.total,
                    type: "na wysokim piętrze"
                }
            );
    }
};

export const getUserFilterChoice = (userPref: IUserPreferences, offer: IOfferDetail | IPropertyDetailOffer) => {
    const areaStats = getBoosterAreaStats(offer, userPref);
    const roomStats = getBoosterRoomStats(offer, userPref);
    const floorStats = getBoosterFloorStats(offer, userPref);

    if (userPref.filters?.area_1 && (areaStats?.left === 1 || areaStats?.left === 2) && areaStats.total && areaStats.total > 2) {
        return "area";
    } else if (userPref.filters?.rooms_0 && (roomStats?.left === 1 || roomStats?.left === 2) && roomStats.total && roomStats.total > 2) {
        return "rooms";
    } else if (
        userPref.filters?.floor_choices &&
        (floorStats?.left === 1 || floorStats?.left === 2) &&
        floorStats.total &&
        floorStats.total > 2 &&
        offer.type === OfferType.FLAT
    ) {
        return "floor";
    }
};

export const getQuarterStats = (quarter: QuarterType, offer: IOfferDetail | IPropertyDetailOffer, property?: IPropertyDetailBoosterStats) => {
    const buildingParam = !property ? offer?.stats?.building_parameters_stats : property.offer.stats?.building_parameters_stats;
    const quarterName = getQuarterTypeName(quarter);
    const quarterNamePL = getQuarterTypeNamePL(quarter);
    return property?.quarters?.includes(quarter) && buildingParam && quarterName
        ? {
              left: buildingParam[`properties_${quarterName}_quarter`]?.left,
              total: buildingParam[`properties_${quarterName}_quarter`]?.total,
              type: quarterNamePL
          }
        : !property && buildingParam && quarterName
          ? {
                left: buildingParam[`properties_${quarterName}_quarter`]?.left,
                total: buildingParam[`properties_${quarterName}_quarter`]?.total,
                type: quarterNamePL
            }
          : undefined;
};
